import React, { useContext } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { useLayoutEffectWithoutSSRComplaining } from '@wix/da-hooks/pkg/useLayoutEffectWithoutSSRComplaining';
import { CommentEditorContext } from './context';
import { useEditorDraftState } from './hooks/useEditorDraftState';
/**
 * Triggers the loading/expansion of the commentbox when there is a draft
 * comment saved in local storage
 */ const DraftCommentAutoTrigger = ({ editorId  })=>{
    const { expandEditor  } = useContext(CommentEditorContext);
    const hasDraft = useEditorDraftState(editorId);
    const isMounted = useIsMounted();
    useLayoutEffectWithoutSSRComplaining(()=>{
        if (!isMounted) {
            return;
        }
        if (hasDraft) {
            expandEditor();
        }
    }, [
        isMounted
    ]);
    return null;
};
DraftCommentAutoTrigger.displayName = 'DraftCommentAutoTrigger';
export default DraftCommentAutoTrigger;
